export default {"src":"/_next/static/media/calendarTwo_64.8ab7cf75.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};